const defaultMenuClass = 'main-menu';

function hideNavigationGroup(themes) {
  const group = $('#mainNavigation .group');
  group.each(function () {
    const groupItem = $(this);
    const theme = themes.find((theme) => groupItem.children().first().text().includes(theme.name));
    if (theme) {
      groupItem.addClass(theme.class + '-menu');

      if (themes.find((theme) => theme.hideManinNav)) {
        groupItem.hide();
      }
    } else {
      groupItem.addClass(defaultMenuClass);
    }
  });
}

function createSecondLevel($group) {
  const $secondLevelList = $group.children();
  if ($secondLevelList.length > 2) {
    $secondLevelList.each(function () {
      const $item = $(this);
      if ($item.hasClass('subitems')) {
        $item.removeClass('subitems');
        $item.addClass('items');
      }
    });
  }
}

function createFirstLevel($menu) {
  $menu.removeClass('items').addClass('groups');
  const $firstLevelList = $menu.children();
  $firstLevelList.first().remove();

  $firstLevelList.each(function () {
    const $group = $(this);
    $group.removeClass('item').addClass('group');
    if ($group.children().length > 2) {
      createSecondLevel($group);
    }
  });
}
// Create the menu structure
function createMenu($menu) {
  const $groups = $($menu).find('.items');
  const $mainNavigationUL = $('#mainNavigation ul.groups');
  $mainNavigationUL.last().after($groups);
  $mainNavigationUL.first().remove();
  createFirstLevel($groups);
}

function applyThemeNavigation(themes) {
  const activeTheme = themes.find((theme) => $('body').hasClass(theme.class));

  if (activeTheme) {
    const $activeMenu = $(`.${activeTheme.class}-menu`);
    $(`.${defaultMenuClass}`).remove();
    createMenu($activeMenu);
  }
}

export default function () {
  const themes = [
    {
      name: subpagePaths.pageName,
      class: subpagePaths.subpageClass,
      homeLink: `${SITEBASEURL}${subpagePaths.sourcePage}`,
      hideManinNav: subpagePaths.disableItemMainTheme,
    },
  ];
  $(window).on('load', function () {
    hideNavigationGroup(themes);
    applyThemeNavigation(themes);
    $('.header .bottom-content').css('opacity', 1);
  });
}
